import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import css from "../css/admin.module.css";
import {ruDate, unique} from "./utils";
import {post} from "./post";


const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export const AdminDialog = ({users}) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const deleteLeads = async (tr) => {
        if (!window.confirm(`Delete User Data ${tr.authData?.displayName} ${tr.authData?.username} ${tr.userId}?`)) return;
        await post("deleteUserData", {leads: tr.leadIds || [tr.id], userId: tr.userId});
    }

    users.sort((a, b) => {
        if (!a.authData) return -1;
        if (!b.authData) return 0;
        return a.authData.displayName > b.authData.displayName ? 1 : -1
    });

    return (
        <>
            <div onClick={handleClickOpen} className={css.pseudolink}>{users.length}</div>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar sx={{position: 'relative'}}><Toolbar><IconButton edge="start" color="inherit" onClick={handleClose}><CloseIcon/></IconButton><Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">Users</Typography></Toolbar></AppBar>
                <table className={css.dialog}>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Delete</th>
                        <th>Created</th>
                        <th>Updated</th>
                        <th>LeadId</th>
                        <th>UserId</th>
                        <th>Name</th>
                        <th>Country</th>
                        <th>IP</th>
                        <th>Browser</th>
                        <th>Language</th>
                        <th>Platform</th>
                        <th>Size</th>
                        <th>Referrer</th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.map((tr, i) => (
                        <tr key={i} onClick={() => console.log(tr)}>
                            <td>{i + 1}</td>
                            <td><button onClick={()=>deleteLeads(tr)}>Delete</button></td>
                            <td>{ruDate(tr.created)}</td>
                            <td>{ruDate(tr.updated)}</td>
                            <td style={{whiteSpace: "nowrap"}}>{(tr.leadIds || [tr.id]).map(t => <div key={t}>{t}<br/></div>)}</td>
                            <td style={{whiteSpace: "nowrap"}}>{tr.userId}</td>
                            <td><a target={"_blank"} href={`?userId=${tr.userId}`}>{tr.authData?.displayName} {tr.authData?.username}</a></td>
                            <td>{unique(tr.ip.map(i => i.id.country)).join(", ")}</td>
                            <td>{unique(tr.ip.map(i => i.id.ip)).join(", ")}</td>
                            <td>{unique((tr.browser).map(i => i.id.browser)).join(", ")}</td>
                            <td>{unique((tr.browser).map(i => i.id.language)).join(", ")}</td>
                            <td>{unique((tr.browser).map(i => i.id.platform)).join(", ")}</td>
                            <td>{unique((tr.browser).map(i => i.id.size)).join(", ")}</td>
                            <td>{unique((tr.referrer || []).map(i => i.id)).join(", ")}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </Dialog>
        </>
    );
}
